module.exports = __webpack_public_path__ + "img/s10.952593b4.png";